import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaLayerGroup, FaSearch, FaBars } from 'react-icons/fa';
import { useCommandPalette } from '../common/CommandPalette';

/* ============================================================
   Barra de navegación inferior — solo en celular. Deja las
   acciones clave al alcance del pulgar: Inicio, Equipos,
   Buscar y el menú completo.
   ============================================================ */

const Bar = styled.nav`
  display: none;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: var(--z-mobilebar);
    padding: 0.35rem 0.4rem calc(0.35rem + env(safe-area-inset-bottom, 0px));
    background: rgba(11, 19, 32, 0.94);
    backdrop-filter: blur(10px);
    border-top: 1px solid var(--border-soft);
  }
`;

const itemStyles = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 0.4rem 0.2rem;
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  font-family: inherit;
  font-size: 0.6rem;
  letter-spacing: 0.02em;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;

  svg { font-size: 1.15rem; }
`;

const Tab = styled(Link)`
  ${itemStyles}
  color: ${({ $active }) => ($active ? 'var(--btn-primary)' : 'var(--text-disabled)')};
`;

const TabBtn = styled.button`
  ${itemStyles}
  color: var(--text-disabled);
  &:active { color: var(--btn-primary); }
`;

const MobileNav = ({ toggleSidebar }) => {
  const location = useLocation();
  const { open: openPalette } = useCommandPalette();
  const isHome = location.pathname === '/';
  const isTeams = location.pathname.startsWith('/equipos');

  return (
    <Bar aria-label="Navegación principal (móvil)">
      <Tab to="/" $active={isHome}>
        <FaHome /> Inicio
      </Tab>
      <Tab to="/equipos" $active={isTeams}>
        <FaLayerGroup /> Equipos
      </Tab>
      <TabBtn type="button" onClick={openPalette} aria-label="Buscar">
        <FaSearch /> Buscar
      </TabBtn>
      <TabBtn type="button" onClick={toggleSidebar} aria-label="Abrir menú">
        <FaBars /> Menú
      </TabBtn>
    </Bar>
  );
};

export default MobileNav;
